import type { Request } from '../../../../index'
import { SalePointCategoriesParamsPost } from 'app/common/types/sale-points/categories'


type PathParamsDto = {
  school_id: number
  sale_point_id: number
}

type ParamsDto = {
  categories_ids: Array<number>
  use_complexes: boolean
  limit_single_item_in_purchase: number | null
}

export const convertParams = (params: SalePointCategoriesParamsPost): [ParamsDto, PathParamsDto] => {
  const { orgId, salePointId, selectedCategories, useComplexes, limitSingleItemInPurchase } = params
  const categoriesIds = selectedCategories.map(id => parseInt(id, 10))
  return [
    {
      categories_ids: categoriesIds,
      use_complexes: useComplexes,
      limit_single_item_in_purchase: limitSingleItemInPurchase,
    },
    { school_id: orgId, sale_point_id: salePointId }]
}


export const POST_SALE_POINT_CATEGORIES: Request<SalePointCategoriesParamsPost, void, PathParamsDto> = [
  'food/schools/{school_id}/sale_points/{sale_point_id}/categories',
  'post',
  ['data', 'categories_ids'],
]
